import { FC } from 'react';

import { CabinetTemplate } from '@/widgets/Templates';

import {
  allAllowedToChoosePassportDocumentTypeCodes,
  allowedForSelectionDocumentTypesForDeclaredPlaceOfResidence,
  allowedToChooseAddressRegDocumentTypeCodes,
} from '@/components/Forms/constants';
import { Loader } from '@/shared/ui';

import { useERZDocumentTypes } from '@/modules/erz/hooks/useERZDocumentTypes';

import ProfileContainer from './ui';

const Profile: FC<unknown> = () => {
  const { data: passportDocumentTypeEntities = [], isLoading: isPassportDocumentTypeEntitiesLoading } =
    useERZDocumentTypes({ allowedDocumentTypeCodes: allAllowedToChoosePassportDocumentTypeCodes });

  const { data: regAddressDocumentTypeEntities = [], isLoading: isRegAddressDocumentTypeEntitiesLoading } =
    useERZDocumentTypes({ allowedDocumentTypeCodes: allowedToChooseAddressRegDocumentTypeCodes });

  const { data: actualAddressDocumentTypeEntities = [] } = useERZDocumentTypes({
    allowedDocumentTypeCodes: allowedForSelectionDocumentTypesForDeclaredPlaceOfResidence,
  });

  return (
    <CabinetTemplate>
      {isPassportDocumentTypeEntitiesLoading || isRegAddressDocumentTypeEntitiesLoading ? (
        <Loader />
      ) : (
        <ProfileContainer
          passportDocumentTypeEntities={passportDocumentTypeEntities}
          regAddressDocumentTypeEntities={regAddressDocumentTypeEntities}
          actualAddressDocumentTypeEntities={actualAddressDocumentTypeEntities}
        />
      )}
    </CabinetTemplate>
  );
};

export default Profile;
